export default __webpack_public_path__ + "static/media/authentification_centralisee.d6b252b7.svg";